/* ===========================================================================
   Piklo — the stockist map.

   Progressive enhancement, strictly. The section has already rendered every
   location as real HTML; nothing here is required for the page to work. If
   Leaflet fails to load, if the tile server is down, if the browser is ancient
   — the list is still sitting there, readable and crawlable. This file only
   ever adds.

   Leaflet is VENDORED in assets/ next to three.js rather than pulled from a CDN,
   and it is only fetched once the map scrolls into view. The same deal the 3D
   can gets: nobody downloads 147KB for a page they bounce off.
   ======================================================================== */
(function (wire) {
  'use strict';
  // Every Stockists section prints this file's script tag, so it can run twice on
  // one page. Run once, and wire each section from its OWN elements: page-wide
  // lookups bound a second section to the first one's map, and its failed boot
  // then removed the first section's map. (2026-10-19)
  if (window.__pikloMap) return;
  window.__pikloMap = true;
  function all() {
    [].forEach.call(document.querySelectorAll('section.stk'), function (sec) {
      if (!sec.__stk) { sec.__stk = true; wire(sec); }
    });
  }
  all();
  document.addEventListener('shopify:section:load', all);   // theme editor re-render
})(function (sec) {
  'use strict';

  var root = sec.querySelector('[data-stk-map]');
  var list = sec.querySelector('[data-stk-list]');
  var hint = sec.querySelector('[data-stk-hint]');   // the card buttons' description
  if (!list) return;

  var items = [].slice.call(list.querySelectorAll('[data-stk-item]'));
  if (!items.length) return;

  /* ---------------------------------------------------------------- state */
  var map = null;
  var markers = [];
  var meMarker = null;
  var booted = false;
  var allBtn = null;     // "All 7 stores", shown while the frame leaves pins out
  var openPin = null;    // the marker whose popup is open
  var landing = null;    // the popup a card click is waiting to open
  var countMsg = '';     // the plain count, under any "Location unavailable"
  // Reduced motion: every view change below jumps instead of gliding.
  var rm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ------------------------------------------------------- state dropdown
     Built from the locations themselves, so it can never list a state with
     nothing in it or miss one that was just added in the editor. */
  var stateSel = sec.querySelector('[data-stk-state]');
  if (stateSel) {
    var seen = {};
    items.forEach(function (li) {
      var st = (li.getAttribute('data-state') || '').trim().toUpperCase();
      if (st && !seen[st]) { seen[st] = true; }
    });
    Object.keys(seen).sort().forEach(function (st) {
      var o = document.createElement('option');
      o.value = st; o.textContent = st;
      stateSel.appendChild(o);
    });
    // one state overall means the filter is decoration; hide it
    if (Object.keys(seen).length < 2) {
      var wrap = stateSel.closest('.stk__filter');
      if (wrap) wrap.hidden = true;
    }
    stateSel.addEventListener('change', applyFilter);
  }

  var countEl = sec.querySelector('[data-stk-count]');
  var noneEl = sec.querySelector('[data-stk-none]');

  function applyFilter() {
    var want = stateSel ? stateSel.value : '';
    var shown = 0;
    items.forEach(function (li) {
      var st = (li.getAttribute('data-state') || '').trim().toUpperCase();
      var ok = !want || st === want;
      li.hidden = !ok;
      if (ok) shown++;
    });
    if (noneEl) noneEl.hidden = shown !== 0;
    countMsg = shown === items.length
      ? items.length + (items.length === 1 ? ' location' : ' locations')
      : shown + ' of ' + items.length;
    if (countEl) countEl.textContent = countMsg;
    // keep the map framed on whatever is actually visible
    if (map && markers.length) {
      markers.forEach(function (m) {
        var vis = !m.__li.hidden;
        if (vis && !map.hasLayer(m)) m.addTo(map);
        if (!vis && map.hasLayer(m)) map.removeLayer(m);
      });
      frame();
    }
  }
  applyFilter();

  /* --------------------------------------------------------------- helpers */

  // Haversine. Miles, because the audience is American and the copy says "mi".
  function milesBetween(a, b, c, d) {
    var R = 3958.8;
    var p = Math.PI / 180;
    var dLat = (c - a) * p, dLng = (d - b) * p;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(a * p) * Math.cos(c * p) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }

  function geoOf(li) {
    var la = parseFloat(li.getAttribute('data-lat'));
    var ln = parseFloat(li.getAttribute('data-lng'));
    return (isFinite(la) && isFinite(ln)) ? [la, ln] : null;
  }

  function asset(name) {
    // Shopify's assets folder is flat and this file lives in it, so a sibling
    // resolves off our own src — no Liquid needed and no hardcoded CDN host.
    var me = document.currentScript || document.querySelector('script[src*="piklo-map"]');
    var base = me ? me.src.replace(/[^/]+$/, '') : '';
    return base + name;
  }

  function load(tag, attrs) {
    return new Promise(function (res, rej) {
      var el = document.createElement(tag);
      Object.keys(attrs).forEach(function (k) { el[k] = attrs[k]; });
      el.onload = res;
      el.onerror = function () { rej(new Error('failed: ' + (attrs.src || attrs.href))); };
      document.head.appendChild(el);
    });
  }

  /* ------------------------------------------------------------ the marker
     A div icon, not an image: it inherits the brand colours from the
     stylesheet, stays crisp at any density, and means Leaflet never looks for
     its default marker PNGs — which would 404, because the flat assets folder
     has no images/ subdirectory for them to sit in. */
  function pin(label) {
    return window.L.divIcon({
      className: 'stk__marker',
      html: '<span class="stk__pin"></span>' +
            (label ? '<span class="stk__mlabel">' + label + '</span>' : ''),
      iconSize: [30, 38],
      iconAnchor: [15, 38],
      popupAnchor: [0, -34]
    });
  }

  // Pins hang up from their point and are only ~42px wide, so the sides need
  // half the room the top does. A flat 48 cost a 360 phone a zoom level (z9),
  // which stacked the Chesterton and Collegedale pins again.
  function fit(pts) {   // points, or a LatLngBounds
    map.fitBounds(window.L.latLngBounds(pts), { padding: [24, 48], maxZoom: 13, animate: !rm });
  }

  // The pins the map opens on: those with at least half of the others within
  // 40 miles. Fitting all seven put the frame at zoom 8 because of Knoxville,
  // ~90 mi out, which piled the six around Chattanooga into one stack where a
  // click on one pin opened another. The outliers stay one tap away (allBtn).
  function cluster(live) {
    var core = live.filter(function (m) {
      var a = m.getLatLng(), near = 0;
      live.forEach(function (o) {
        var b = o.getLatLng();
        if (o !== m && milesBetween(a.lat, a.lng, b.lat, b.lng) <= 40) near++;
      });
      return near >= (live.length - 1) / 2;
    });
    return core.length > 1 ? core : live;
  }

  function frame() {
    map.closePopup();   // a popup left open across a refit hangs off the map's edge
    var live = markers.filter(function (m) { return !m.__li.hidden; });
    if (!live.length) return;
    var box = null;
    if (live.length === 1 && !meMarker) {
      map.setView(live[0].getLatLng(), parseInt(root.dataset.zoom, 10) || 10, { animate: !rm });
    } else {
      // Filtered to a state: everything that is showing. Otherwise the cluster,
      // plus the visitor and their nearest store once located (all seven again
      // would put a Chattanooga visitor back at zoom 8 with the pins stacked).
      var core = (stateSel && stateSel.value) ? live : cluster(live);
      var pts = core.map(function (m) { return m.getLatLng(); });
      if (meMarker) {
        pts.push(meMarker.getLatLng());
        pts.push(live.slice().sort(function (a, b) { return a.__li.__d - b.__li.__d; })[0].getLatLng());
      }
      box = window.L.latLngBounds(pts);
      fit(box);
    }
    if (allBtn) {
      allBtn.hidden = !box || live.every(function (m) { return box.contains(m.getLatLng()); });
      allBtn.textContent = 'All ' + live.length + ' stores';
      allBtn.setAttribute('aria-label', 'Show all ' + live.length + ' stores on the map');
    }
  }

  /* ----------------------------------------------------------------- boot */
  function boot() {
    if (booted || !root) return;
    booted = true;

    Promise.all([
      load('link', { rel: 'stylesheet', href: asset('leaflet.min.css') }),
      load('script', { src: asset('leaflet.min.js'), async: true })
    ]).then(function () {
      if (!window.L) throw new Error('Leaflet absent after load');

      map = window.L.map(root, {
        scrollWheelZoom: false,   // a map that eats the page scroll is a menace
        // ...and so is one that eats the thumb: drag + touch zoom together make the
        // map touch-action:none. On touch screens one finger scrolls the page and two
        // fingers pan and pinch. (pointer: coarse), not L.Browser.mobile, which misses iPads.
        dragging: !(window.matchMedia && window.matchMedia('(pointer: coarse)').matches),
        zoomControl: true,
        attributionControl: true,
        zoomAnimation: !rm, fadeAnimation: !rm, markerZoomAnimation: !rm
      });
      // ...and the pans jump too. A popup's autopan has no animate option of its
      // own, so it goes through this map's panBy (as do the arrow keys).
      if (rm) {
        var panBy = map.panBy;
        map.panBy = function (offset, opts) {
          return panBy.call(map, offset, window.L.extend({}, opts, { animate: false }));
        };
      }

      // One host: OSM retired the a/b/c.tile subdomains.
      window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      items.forEach(function (li) {
        var g = geoOf(li);
        if (!g) return;
        var name = li.getAttribute('data-name') || '';
        var m = window.L.marker(g, { icon: pin(name), title: name, riseOnHover: true });
        m.__li = li;
        m.bindPopup(buildPopup(li));   // sized and padded by padPopups() below
        // on popupopen, not click: Enter on a focused pin opens it without a click
        m.on('popupopen', function () { openPin = m; highlight(li); });
        m.on('popupclose', function () { if (openPin === m) openPin = null; });
        m.addTo(map);
        markers.push(m);

        // The name becomes the card's keyboard handle: a real button, so Tab
        // reaches it and Enter or Space fires the click below. Made here, so a map
        // that never boots leaves no dead button behind.
        var nm = li.querySelector('.stk__name');
        if (nm && !nm.querySelector('.stk__show')) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'stk__show';
          btn.textContent = nm.textContent.trim();
          // Named by its text, never an aria-label: the heading takes its name from
          // the button, and every store heading was read "Show <name> on the map".
          if (hint) btn.setAttribute('aria-describedby', hint.id);
          nm.textContent = '';
          nm.appendChild(btn);
        }

        // clicking a card should move the map, not just scroll the page
        li.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;   // let real links be links
          // Bring the map back if it is off screen or under the sticky header: on
          // a phone the list sits below it, so the popup opened out of sight.
          var r = root.getBoundingClientRect();
          var hdr = document.querySelector('.hdr');
          var clear = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
          if (r.top < clear || r.bottom > window.innerHeight) {
            root.scrollIntoView({ block: 'center', behavior: rm ? 'auto' : 'smooth' });
          }
          // Open the popup once the map has landed. Opened straight away, its
          // autopan stopped the glide dead, so after the first card the map quit
          // centring and could leave the popup under the ± control. The wait is
          // set up AFTER setView, which first stops any glide still running: that
          // glide's moveend would otherwise open this popup before the move.
          var z = Math.max(map.getZoom(), 12);
          if (landing) map.off('moveend', landing);   // a newer card wins
          map.closePopup();   // reopened after the move, so its autopan runs again
          map.setView(g, z, { animate: !rm });
          landing = function () { landing = null; m.openPopup(); };
          if (map.getZoom() === z && map.latLngToContainerPoint(g).distanceTo(map.getSize().divideBy(2)) < 2) {
            landing();   // a jump (reduced motion, or the same card again) has landed already
          } else {
            map.once('moveend', landing);
          }
          highlight(li);
        });
      });

      // Popups keep clear of the controls, ± top left and "All 7 stores" top
      // right: beside ± where a popup fits, below both on a phone, where one
      // beside ± ran off the right edge, and never wider than the map. On a short
      // map (a landscape phone) they may rise to the top, or the pin under them
      // drops out of the frame.
      function padPopups() {
        var s = map.getSize(), narrow = s.x < 420;
        markers.forEach(function (m) {
          window.L.setOptions(m.getPopup(), {
            maxWidth: Math.min(300, s.x - 60),
            autoPanPaddingTopLeft: [narrow ? 12 : 56, s.y < 300 ? 10 : narrow ? 84 : 48],
            autoPanPaddingBottomRight: [12, 12]
          });
        });
      }
      padPopups();
      map.on('resize', padPopups);

      // One tap back out to every store while the frame leaves some out.
      var allCtl = window.L.control({ position: 'topright' });
      allCtl.onAdd = function () {
        allBtn = window.L.DomUtil.create('button', 'stk__all');
        allBtn.type = 'button';
        window.L.DomEvent.disableClickPropagation(allBtn);
        allBtn.addEventListener('click', function () {
          map.closePopup();
          fit(markers.filter(function (m) { return !m.__li.hidden; })
                     .map(function (m) { return m.getLatLng(); }));
        });
        return allBtn;
      };
      allCtl.addTo(map);

      // Escape closes the popup. Leaflet only listens while the map box itself
      // has focus, never from a focused pin, a popup link or a card's button.
      // Focus that was inside the popup goes back to its pin.
      function esc(e) {
        if (e.key !== 'Escape' || !openPin) return;
        var src = openPin;
        var pop = src.getPopup().getElement();
        var inside = !!(pop && pop.contains(document.activeElement));
        map.closePopup();
        if (inside && src.getElement()) src.getElement().focus();
      }
      root.addEventListener('keydown', esc);
      list.addEventListener('keydown', esc);

      frame();
      root.classList.add('is-live');
    }).catch(function (err) {
      // The list is already on the page, so the honest move is to remove the
      // dead frame rather than leave a grey hole above it.
      if (window.console) console.warn('[piklo map]', err.message);
      var wrap = root.closest('.stk__mapwrap');
      if (wrap) wrap.remove();
    });
  }

  function buildPopup(li) {
    var name = li.getAttribute('data-name') || '';
    var addr = li.querySelector('.stk__addr');
    var dir = li.querySelector('.stk__act--dir');
    var html = '<strong class="stk__pname">' + name + '</strong>';
    if (addr) html += '<span class="stk__paddr">' + addr.innerHTML + '</span>';
    if (dir) html += '<a class="stk__pdir" target="_blank" rel="noopener" href="' + dir.href + '">Directions</a>';
    return html;
  }

  function highlight(li) {
    items.forEach(function (o) { o.classList.toggle('is-on', o === li); });
    // ...and its pin: .stk__marker.is-on was styled but never set
    markers.forEach(function (m) {
      var el = m.getElement();
      if (el) el.classList.toggle('is-on', m.__li === li);
    });
  }

  /* Only pay for Leaflet when the map is about to be seen. */
  if (root) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); boot(); } });
      }, { rootMargin: '300px 0px' });
      io.observe(root);
    } else {
      boot();
    }
  }

  /* ---------------------------------------------------------- "near me"
     Never on load. A permission prompt nobody asked for gets denied, and
     browsers remember the denial — so it is spent only when someone asks. */
  var nearBtn = sec.querySelector('[data-stk-near]');
  // The words have their own span: setting the button's text wiped the pin dot.
  var nearLbl = nearBtn && (nearBtn.querySelector('[data-stk-near-label]') || nearBtn);
  if (nearBtn && navigator.geolocation) {
    nearBtn.addEventListener('click', function () {
      nearBtn.classList.add('is-busy');
      nearBtn.disabled = true;

      navigator.geolocation.getCurrentPosition(function (pos) {
        var la = pos.coords.latitude, ln = pos.coords.longitude;

        // Sort the DOM by real distance and show it on each card.
        var withGeo = [];
        items.forEach(function (li) {
          var g = geoOf(li);
          var el = li.querySelector('[data-stk-dist]');
          if (!g) { li.__d = Infinity; return; }
          var d = milesBetween(la, ln, g[0], g[1]);
          li.__d = d;
          if (el) {
            el.textContent = (d < 10 ? d.toFixed(1) : Math.round(d)) + ' mi';
            el.hidden = false;
          }
          withGeo.push(li);
        });
        items.slice().sort(function (a, b) { return a.__d - b.__d; })
             .forEach(function (li) { list.appendChild(li); });

        list.classList.add('is-sorted');
        nearBtn.classList.remove('is-busy');
        nearLbl.textContent = withGeo.length ? 'Closest first' : 'Located';
        nearBtn.disabled = true;
        if (countEl) countEl.textContent = countMsg;   // clear an earlier "unavailable"

        if (map && window.L) {
          if (meMarker) map.removeLayer(meMarker);
          meMarker = window.L.marker([la, ln], {
            icon: window.L.divIcon({ className: 'stk__me', html: '<span></span>', iconSize: [18, 18] }),
            title: 'You are here',
            zIndexOffset: -500
          }).addTo(map);
          frame();
        }
      }, function () {
        // Denied, timed out, or unavailable — all the same to the visitor.
        nearBtn.classList.remove('is-busy');
        nearBtn.disabled = false;
        nearLbl.textContent = 'Location unavailable';
        setTimeout(function () {
          nearLbl.textContent = nearBtn.dataset.label || 'Find the closest';
        }, 2600);
        // The note that lasts, and is announced: the count is the bar's live region.
        if (countEl) countEl.textContent = 'Location unavailable — ' + countMsg;
        // Offer the filter only when it is a real choice: "Everywhere" plus one
        // state is a menu that changes nothing.
        if (stateSel && stateSel.options.length > 2) {
          var w = stateSel.closest('.stk__filter');
          if (w) { w.hidden = false; w.classList.add('is-hint'); }
        }
      }, { enableHighAccuracy: false, timeout: 9000, maximumAge: 600000 });
    });
    nearBtn.dataset.label = nearLbl.textContent.trim();
  } else if (nearBtn) {
    nearBtn.hidden = true;   // no geolocation support at all
  }
});
